<template>
    <!--
    <v-bottom-sheet
        :value="value"
        content-class="half-round peek"
        class="pb-3"
        @click:outside="$emit('close')"
        ><v-card class="half-round min-h-screen"
            ><v-card-title 
                ><v-btn
                    class="mr-3"
                    style="margin-left: -12px"
                    icon
                    @click="$emit('close')"
                    ><v-icon>chevron_left</v-icon></v-btn
                >{{ teacher.name }}
                <div class="flex mt-3">
                    <v-list-item-avatar class="my-0" size="64">
                        <v-img :src="teacher.profile_photo_url"></v-img>
                    </v-list-item-avatar>
                    <div class="flex-col align-self-center">
                        <v-list-item-subtitle style="line-height: 18px">
                            {{ teacher.pronouns }}
                        </v-list-item-subtitle>
                        <template>
                            <SoliTeacherCert
                                v-if="teacher.certification_level"
                                :teacher="teacher"
                        /></template>
                    </div>
                </div>
            </v-card-title>
            <v-container>
                {{ teacher.bio?.content }}
            </v-container></v-card
        ></v-bottom-sheet
    >-->

    <SoliChoice
        v-if="value"
        :bottom="$vuetify.breakpoint.xs"
        textOnly
        backButton
        :title="teacher.name"
        fullscreen
        @reset="$emit('close')"
        ><template>
            <div class="flex">
                <v-list-item-avatar
                    class="my-0 ml-3"
                    :size="$vuetify.breakpoint.width < 350 ? 64 : $vuetify.breakpoint.xs ? 86 : 96"
                >
                    <v-img :src="teacher.profile_photo_url"></v-img>
                </v-list-item-avatar>
                <div class="align-self-center flex flex-col gap-1">
                    <v-list-item-subtitle
                        class="font-bold"
                        style="white-space: normal"
                    >
                        {{
                            `${teacher.pronouns ? teacher.pronouns + ' | ' : ''}${
                                teacher.instruments.length > 3
                                    ? teacher.instruments.filter((e, idx) => 3 > idx).map((i) => ' ' + i.name) + '...'
                                    : teacher.instruments.map((i) => ' ' + i.name)
                            }`
                        }}
                    </v-list-item-subtitle>
                    <template>
                        <SoliTeacherCert
                            v-if="teacher.certification_level"
                            :teacher="teacher"
                    /></template>
                    <v-list-item-subtitle
                        v-if="selectedInstrument"
                        class="align-center mr-1 flex flex-wrap gap-1"
                        ><small class="mr-1 font-bold">Teaches:</small>
                        <v-chip
                            v-for="age in [...ageRanges, ...skillLevels]"
                            color="accent"
                            :key="age"
                            x-small
                            >{{ `${age}` }}</v-chip
                        ></v-list-item-subtitle
                    >
                </div>
            </div>

            <div
                class="px-3 pb-3"
                style="overflow-y: auto; white-space: pre-line"
            >
                {{ teacher.bio?.content }}
            </div>
        </template></SoliChoice
    >
</template>

<script>
export default {
    props: {
        teacher: {
            type: Object,
            default: () => {},
        },
        value: {
            type: Boolean,
            default: false,
        },
        selectedInstrument: {
            type: Number,
            default: null,
        },
    },
    computed: {
        getInstrument() {
            if (!this.selectedInstrument) return;

            return this.teacher.instrument_users.find((e) => e.instrument_id == this.selectedInstrument);

            /* let skillLevels = instrument.pivot.skill_levels.map((e) => e.name);
            let ageRanges = instrument.pivot.age_ranges.map((e) => e.name);

            let attributes = [
                ...(skillLevels.length == 3 ? "All Levels" : skillLevels),
                ...(ageRanges.length == 3 ? "All Ages" : ageRanges),
            ];

            return attributes;*/
        },
        skillLevels() {
            let skillLevels = this.getInstrument.skill_levels.map((e) => e.name);
            return skillLevels.length == 3 ? ['All Levels'] : skillLevels;
        },
        ageRanges() {
            let ageRanges = this.getInstrument.age_ranges.map((e) => e.name);
            return ageRanges.length == 3 ? ['All Ages'] : ageRanges;
        },
    },
};
</script>
